



import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component({
  name: 'Canvas'
})

export default class Circular extends Vue {
  canvas = null
  ctx = null
  timers = 0
  arr: any[] = []
  width = window.innerWidth
  height = window.innerWidth <= 484 ? window.innerHeight : window.innerHeight / 2

  @Prop({
    default: 0,
    type: Number
  }) index!: number

  @Watch('index')
  setTimer (news: any) {
    if (news !== 2) {
      window.cancelAnimationFrame(this.timers)
    } else {
      this.timers = window.requestAnimationFrame(this.animate)
    }
  }

  destroyed () {
    window.cancelAnimationFrame(this.timers)
  }

  mounted () {
    (window as any).requestAnimFrame = (function () {
      return window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      (window as any).mozRequestAnimationFrame ||
      function (callback) {
        window.setTimeout(callback, 1000 / 60)
      }
    })()
    const canvas = document.getElementById('canvas') as any
    const ctx = canvas.getContext('2d') as any
    (this.canvas as any) = canvas
    this.ctx = ctx as any
    (this.ctx as any).globalAlpha = 0.2
    this.initCircular(this)
    this.play()
    setTimeout(() => {
      this.animate()
    }, 1000)
    // console.log(this.index, 7894)
  }

  random (min, max) {
    return Math.random() * (max - min) + min
  }

  play () {
    console.log(this.arr, 1100)
    for (let i = 0; i < this.arr.length; i++) {
      (this.arr[i] as any).draw()
    }
  }

  initCircular (that) {
    class Circular {
      w: number
      h: number
      x: number
      y: number
      vx: number
      vy: number
      color: string

      constructor () {
        this.w = that.random(9, 20)
        this.h = this.w
        this.x = that.random(0, that.width)
        this.y = that.random(0, that.height)
        this.vx = that.random(-1.1, 1.1)
        this.vy = that.random(-1.1, 1.1)
        this.color = '#' + Math.floor(Math.random() * 0xffffff).toString(16) // 随机色
      }

      draw () {
        that.ctx.beginPath()
        that.ctx.arc(this.x, this.y, this.w / 2, 0, Math.PI * 2, true)
        that.ctx.fillStyle = this.color
        that.ctx.fill()
      }

      move () {
        this.x += this.vx
        this.y += this.vy
        if (this.x + this.w >= that.width || this.x - this.w / 2 <= 0) {
          this.vx = -this.vx
        }
        if (this.y + this.h >= that.height || this.y - this.h / 2 <= 0) {
          this.vy = -this.vy
        }
        this.draw()
      }
    }
    for (let i = 0; i < 10; i++) {
      this.arr.push(new Circular())
    }
  }

  animate () {
    (this.ctx as any).clearRect(0, 0, this.width, this.height)
    for (let i = 0; i < this.arr.length; i++) {
      this.arr[i].move()
    }
    this.timers = window.requestAnimationFrame(this.animate)
  }
}
